import React from 'react'
import Styled from 'styled-components'

const Container = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8rem 2rem;
  font-family: ${props => props.theme.fonts.primary.css};
  color: ${props => props.theme.colors.black.shade500.css};
  background-color: ${props => props.theme.colors.primary.shade300.css};
`

const Headline = Styled.h2``

const Tagline = Styled.h3``

const Slogan = Styled.h5``

export default ({ attrs }) => (
  <Container>
    <Headline>{attrs.headline}</Headline>
    <Tagline>{attrs.tagline}</Tagline>
    <Slogan>{attrs.slogan}</Slogan>
  </Container>
)


// WEBPACK FOOTER //
// ./src/shared/components/Header/index.js